// API endpoints
export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/auth/login',
    REGISTER: '/auth/register',
    LOGOUT: '/auth/logout',
    CURRENT_USER: '/auth/me',
    FORGOT_PASSWORD: '/auth/forgot-password',
    RESET_PASSWORD: '/auth/reset-password',
    VERIFY_EMAIL: '/auth/verify-email',
  },
  USERS: {
    BASE: '/users',
    BY_ID: (id: string) => `/users/${id}`,
  },
};

// Pagination defaults
export const PAGINATION = {
  DEFAULT_PAGE: 0,
  DEFAULT_ROWS_PER_PAGE: 10,
  ROWS_PER_PAGE_OPTIONS: [5, 10, 25, 50],
};

// Local storage keys
export const STORAGE_KEYS = {
  TOKEN: 'token',
  USER: 'user',
  THEME: 'theme',
  LANGUAGE: 'language',
};

// Theme options
export const THEME_OPTIONS = {
  LIGHT: 'light',
  DARK: 'dark',
  SYSTEM: 'system',
};

// Date formats
export const DATE_FORMATS = {
  DISPLAY: 'MMM dd, yyyy',
  INPUT: 'yyyy-MM-dd',
  API: 'yyyy-MM-dd',
  DISPLAY_WITH_TIME: 'MMM dd, yyyy HH:mm',
  API_WITH_TIME: 'yyyy-MM-dd\'T\'HH:mm:ss.SSS\'Z\'',
};

// Error messages
export const ERROR_MESSAGES = {
  GENERIC: 'An error occurred. Please try again.',
  NETWORK: 'Network error. Please check your connection.',
  UNAUTHORIZED: 'You are not authorized to perform this action.',
  NOT_FOUND: 'The requested resource was not found.',
  VALIDATION: 'Please check your input and try again.',
  SERVER: 'Server error. Please try again later.',
};

// Success messages
export const SUCCESS_MESSAGES = {
  PASSWORD_RESET: 'Password reset successfully.',
  PROFILE_UPDATED: 'Profile updated successfully.',
};

// Routes
export const ROUTES = {
  HOME: '/',
  DASHBOARD: '/dashboard',
  LOGIN: '/auth/login',
  REGISTER: '/auth/register',
  FORGOT_PASSWORD: '/auth/forgot-password',
  RESET_PASSWORD: '/auth/reset-password',
  VERIFY_EMAIL: '/auth/verify-email',
  SETTINGS: '/settings',
  PROFILE: '/profile',
  NOT_FOUND: '/404',
};

export const USER_GUIDE_ROUTES: Array<{
  match: string | string[];
  path: string;
}> = [
  { match: '/dashboard', path: '/16-admin-portal/#admin-dashboard' },
  {
    match: ['/admin/organization', '/admin/create-organization'],
    path: '/16-admin-portal/#organization-management',
  },
  {
    match: '/admin/organization-admin-users',
    path: '/16-admin-portal/#organization-admin-users',
  },
  { match: '/admin/global-config', path: '/16-admin-portal/#global-configuration' },
  { match: '/tenants', path: '/16-admin-portal/#tenant-management' },
  { match: '/profile', path: '/01-getting-started/#user-profile' },
];
